import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Spin, List } from "antd";
import { store } from "../api/index";
import { getStoreInfo } from "../redux/actions/storeInfo";
// Components
import Product from "../components/Product";

//Actions
import { getProducts as listProducts } from "../redux/actions/productActions";
import { getCategories } from "../redux/actions/category";
import Breadcrumb from "../components/Breadcrumb";

const Shop = ({ storeCurrency }) => {
  const dispatch = useDispatch();
  const getProducts = useSelector((state) => state.getProducts);
  const categoryList = useSelector((state) => state.category);
  const [category, setCategory] = useState();
  const { products, loading } = getProducts;
  const [proList, setProList] = useState(getProducts);

  useEffect(() => {
    dispatch(listProducts());
    dispatch(getCategories());
    dispatch(getStoreInfo(store));
  }, [dispatch]);

  useEffect(() => {
    setProList(products);
    const pr = products?.filter((p) => p?.category?._id === category);
    setProList(pr.length === 0 ? products : pr);
  }, [products, category]);
  console.log("category", categoryList);
  return (
    <div>
      <Breadcrumb heading={"All Products"} />
      <div className="container mx-auto">
        <Spin spinning={loading}>
          <div className="container mx-auto">
            <div className="md:grid grid-cols-3 p-10 gap-4">
              <aside className="filter bg-pink p-5">
                <h3>Filters</h3>
                <div className="p_filter_widgets my-4">
                  <div className="l_w_title mb-2">
                    <h4>Browse Categories</h4>
                  </div>
                  {categoryList?.length > 0 ? (
                    <Radio.Group
                      onChange={(e) => setCategory(e?.target?.value)}
                      value={category}
                    >
                      <Radio.Button>None</Radio.Button>
                      {categoryList?.map((category) => (
                        <Radio.Button value={category?._id} key={category?._id}>
                          {category?.name}
                        </Radio.Button>
                      ))}
                    </Radio.Group>
                  ) : (
                    "No categories available in this store."
                  )}
                </div>
              </aside>
              <div className="col-span-2">
                {proList?.length > 0 ? (
                  <List
                    grid={{
                      column: 3,
                    }}
                    itemLayout="horizontal"
                    size="large"
                    pagination={{
                      onChange: (page) => {
                        console.log(page);
                      },
                      pageSize: 9,
                    }}
                    dataSource={proList}
                    renderItem={(item) => (
                      <List.Item className="padding-2">
                        <Product
                          key={item._id}
                          name={item.name}
                          price={item.price}
                          image={item.image}
                          _id={item._id}
                          storeCurrency={storeCurrency}
                        />
                      </List.Item>
                    )}
                  />
                ) : (
                  <div className="text-center">
                    No products available in this store.
                  </div>
                )}
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};

export default Shop;
